export default __webpack_public_path__ + "static/media/standardResearch.d8859f01.png";